export default __webpack_public_path__ + "static/quad-logo-horizontal@3x-290097f533bf2eec9bf7ab2036dbd646.png";